<form class="d-flex" [formGroup]="filterFormGroup">
  <sk-text
    data-test="dms-filter-byName-input"
    class="me-2"
    [label]="'label.FilterByName' | translate"
    formControlName="name"
    [showClear]="true"
  ></sk-text>
  <sk-datetime
    class="me-2"
    data-test="dms-filter-from-date"
    [label]="'label.From' | translate"
    formControlName="from"
    [dateTimePickerType]="datePickerType"
  />
  <sk-datetime
    class="me-2"
    data-test="dms-filter-to-date"
    [label]="'label.To' | translate"
    formControlName="to"
    [dateTimePickerType]="datePickerType"
  />
  <div class="d-flex flex-column justify-content-center pb-2">
    <sk-button
      [appearance]="'icon'"
      data-test="tile-view-lite_reset-filters-button"
      [disabled]="!filterFormGroup.dirty"
      [matTooltip]="'label.ResetFilter' | translate"
      (click)="resetFilters()">
      <i class="fas fa-backspace icon"></i>
    </sk-button>
  </div>
</form>
@if (!!items.length) {
  <div
    infiniteScroll
    [scrollWindow]="false"
    (scrolled)="onScroll($event)"
    [irisResizeObserver]="50"
    (resizeObserverChanged)="tileViewSizeChanged($event)"
    *irisIfLoaded="!loading(); loaderType 'fill'"
    class="h-100 overflow-auto tile-view-wrapper">
    @for (file of items; track file.id) {
      <iris-tile-view-file-card
        [selected]="isFileSelected(file)"
        (selectionChanged)="fileSelectionChanged($event, file)"
        [file]="file"
      ></iris-tile-view-file-card>
    }
  </div>
} @else {
  <iris-empty-content-view
    label="text.dms.EmptyFolder"
    message="text.dms.UploadFilesHere"
    [hasChildren]="true"
  ></iris-empty-content-view>
}
